import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'
  import { CourseModule } from '@/store/modules/course'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import ExamStartPage from '@/components/course/ExamStartPage.vue'
  import useCourse from '@/composables/useCourse'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'KnowledgeCheckInfo',
  setup(__props) {

  const { fetchingCourseInfo, currentCourseId } = useCourse()
  const { setIsLoadingComponentViewData } = useCommonMixin()

  setIsLoadingComponentViewData(true)
  CourseModule.getCourse({ courseId: currentCourseId.value })

  watch(fetchingCourseInfo, (value) => {
    setIsLoadingComponentViewData(value)
  })

return { __sfc: true,fetchingCourseInfo, currentCourseId, setIsLoadingComponentViewData, watch, CourseModule, LoadingSpinner, ExamStartPage, useCourse, useCommonMixin }
}

})